import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Paper, Typography, Grid, Link } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import OrganizationSection from './OrganizationSection';
import GroupSizeSection from './GroupSizeSection';
import { genfunction } from 'helpers';
import { actionGetExtraItem } from 'actions';

const { NoExtraItemFoundMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    arrowBtn: {
        float: 'left',
        marginLeft: '10px',
        marginTop: '3px'
    },
    section: {
        marginTop: '10px',
        borderRadius: "0",
        width: "100%"
    },

}));

const GroupReservationDrawer = (props) => {
    const classes = useStyles();
    const [errorMsg, seterrorMsg] = useState("");
    const [showOrganization, setShowOrganization] = useState(false);
    const [disableBeforeLoading, setDisableBeforeLoading] = useState(true);

    const dispatch = useDispatch();

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0];
    const tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
    const tourEvent = tourEvents && tourEvents.length > 0 ? tourEvents.filter(x => x.TourEventID == props.tourEventId)[0] : null;
    const reducerAppLoader = useSelector(state => state.reducerAppLoader.loading);
    const organizationList = useSelector(state => state.reducerOrganizationSection.organizationlist);

    useEffect(() => {
        if (reducerAppLoader === false)
            setDisableBeforeLoading(false);

    }, [reducerAppLoader])

    const continueHandler = () => {

        if (validateOrganization() && validateGroupSize()) {

            let organizationCostRate = genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID) && organizationList.length > 0 ? organizationList.filter(x => x.CustomerID === props.organizationID)[0].CostRateID : "";
            actionGetExtraItem(dispatch, props.tourEventId, props.ismembershipapplied, props.membercostrate, props.isIDME, props.isIDMECostrate, organizationCostRate)

            props.goToExtraItemOrGroupDrawer(true);
        }
    }

    const validateGroupSize = () => {

        if (bkngType.ShowTourProductsBasedOnGroupSize && props.groupSize === "") {
            seterrorMsg("Please select Group Size")
            return false
        }
        else if (bkngType.ShowTourProductsBasedOnGroupSize && tourEvent.TourProducts.findIndex(x => x.LimitDisplayOnGroupSize && x.GroupSize === props.groupSize) == -1) {
            seterrorMsg(NoExtraItemFoundMsg)
            return false
        }
        else
            return true
    }

    const validateOrganization = () => {
        if ((bkngType.RequireCompanyName || showOrganization || (!bkngType.ShowTourProductsBasedOnGroupSize && props.isContinueToGroupDrawer)) && props.organizationID === "") {
            seterrorMsg("Please select an organization")
            return false
        }
        else
            return true
    }

    const handleChange = (value) => {
        setShowOrganization(value);
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
    }


    return (
        <div>
            <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
            <Grid container>
                <Paper className={classes.root}>
                    <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "10px" }}>
                        {window.matchMedia("(min-width: 600px)").matches ? "" : <ArrowBackIosIcon className={classes.arrowBtn} onClick={() => { props.toggleDrawer("right", false) }} />}
                        {tourEvent ? tourEvent.EventName : null}
                    </Typography>
                </Paper>

                <Grid className={classes.section}>
                    {bkngType.RequireCompanyName || bkngType.AllowedCustomerTypes === 'All' ?
                        <OrganizationSection bookingtypeID={props.bookingtypeID} organizationID={props.organizationID} showOrganization={showOrganization} handleChange={handleChange}
                            onChange={props.onChangeOrganization} tourEventId={props.tourEventId} isContinueToGroupDrawer={props.isContinueToGroupDrawer} />
                        : null}

                </Grid>

                <Grid className={classes.section}>
                    {bkngType.ShowTourProductsBasedOnGroupSize ?
                        <GroupSizeSection bookingtypeID={props.bookingtypeID} groupSize={props.groupSize}
                            onChange={props.onChangeGroupSize} tourEventId={props.tourEventId} isEditEvent={props.isEditEvent}
                            toggleIsEdit={props.toggleIsEdit} />
                        : null}
                </Grid>

                <Grid style={{ paddingTop: "20px" }} container alignItems="center" item xs={12} ms={12} lg={12}>
                    <Grid item xs={3} ms={3} lg={3}></Grid>
                    <Grid item xs={6} ms={6} lg={6} align='center'>
                        <Button variant="contained" size="small" color="primary" disabled={disableBeforeLoading}
                            onClick={() => continueHandler()}>Continue</Button>
                    </Grid>
                    <Grid item xs={3} ms={3} lg={3}></Grid>
                </Grid>


            </Grid>

        </div >
    );
}

export default GroupReservationDrawer;
